export default {
  header: {
    logoText: 'Global Hub',
  },
  sections: {
    basicInfo: '招聘要项',
    requirements: '应聘要求',
    workingConditions: '工作条件',
    salaryBenefits: '薪资・福利',
  },
  fields: {
    companyName: '公司名称',
    jobType: '职位类型',
    industry: '行业',
    recruitmentTarget: '招聘对象',
    transfer: '调动',
    urgent: '急招',
    employmentType: '雇佣形式',
    employmentPeriod: '雇佣期限',
    probationPeriod: '试用期',
    interviewMethod: '面试方法',
    jobDescription: '工作内容',
    careerPath: '职业发展',
    workplaceAtmosphere: '工作氛围',
    selectionProcess: '选拔流程',
    japaneseLevel: '日语水平',
    requiredQualifications: '必需资格（语言以外）',
    requiredSkills: '必需条件',
    preferredSkills: '优先条件',
    desiredExperience: '希望的经验 / 人物形象',
    workplace: '工作地点',
    address: '地址',
    nearestStation: '最近车站',
    workingHours: '工作时间・天数',
    holidays: '休假',
    salary: '薪资',
    benefits: '福利',
  },
  values: {
    yes: '有',
    no: '无',
    isTrue: '是',
    isFalse: '否',
    web: 'Web',
  },
};
